import $ from 'jquery';
import {initRevealAnimation} from '../../js/Ui.mjs';

const NEWS_TEMPLATE_LAYOUT_VIDEO = 3;
const $newsListExtend = $('.ef-news-list__extend');
const newsTemplateLayout = parseInt($newsListExtend.data('news-layout'));
const $nextNewsLink = $newsListExtend.find('a.btn');

// fill article count
$('.ef-news-list').each((index, list) => {
  const $list = $(list);
  $list.find('.js_ef-news-list-total-count').text($list.data('allNewsCount'));
});

$nextNewsLink.on('click', function(event) {
  const $moreLink = $(this);
  const nextPageUrl = $moreLink.attr('href');

  event.preventDefault();

  if ($moreLink.hasClass('disabled')) {
    return;
  }
  $moreLink.addClass('disabled');

  $.ajax({
    url: nextPageUrl,
    method: 'GET',
    dataType: 'html',
    success: function(data) {
      const $data = $(data);
      const $nextNewsLink = $data.find('.ef-news-list__extend > a.btn');
      const $showNewsCount = $('#js_ef-news-list-count');
      let $articles;
      let $revealItems;

      if (newsTemplateLayout === NEWS_TEMPLATE_LAYOUT_VIDEO) {
        // Video News
        $articles = $data.find('.ef-news-list__latest-item');
        $articles.find('.ef-button-play').removeClass('d-none');
        $('.ef-news-list__latest').append($articles);
        $revealItems = $articles.find('.reveal');
      } else {
        // General News
        $articles = $data.find('.ef-news-list__further-item');
        $('.ef-news-list__further').append($articles);
        $revealItems = $articles;
      }
      initRevealAnimation($revealItems);

      $showNewsCount.text(parseInt($showNewsCount.text()) + $articles.length);

      if ($nextNewsLink.length) {
        $moreLink.attr('href', $nextNewsLink.attr('href'));
        $moreLink.removeClass('disabled');
      } else {
        $moreLink.remove();
      }
    },
  });
});
